// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BNwf2","colMin":"styles_colMin__X_f2Q"};